import { render, staticRenderFns } from "./ConcentPersonalData.vue?vue&type=template&id=052d06bc&scoped=true&"
import script from "./ConcentPersonalData.vue?vue&type=script&lang=js&"
export * from "./ConcentPersonalData.vue?vue&type=script&lang=js&"
import style0 from "./ConcentPersonalData.vue?vue&type=style&index=0&id=052d06bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d06bc",
  null
  
)

export default component.exports